import useToast from '@hooks/ui/useToast';
import { OrderLine } from '@models/order';
import { cartActions } from '@store/cart/cartSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

// 전역 상태만 변경하고, 실제 API 반영은 useBulkUpdateCartQuantity에서 수행
function useModifyCartItem(item: OrderLine) {
    const { shopItemId, cartItemId } = item;
    const toast = useToast();
    const dispatch = useDispatch();
    const { t } = useTranslation('cart');

    const handleDelete = () => {
        dispatch(cartActions.removeItemByCartItemId(cartItemId!));
        toast.info(t('toast.itemDeleted'));
    };

    const handleDecrease = () => {
        dispatch(cartActions.updateItemQuantity({
            cartItemId: cartItemId!, itemId: shopItemId, amount: -1,
        }));
    };

    const handleIncrease = () => {
        dispatch(cartActions.updateItemQuantity({
            cartItemId: cartItemId!, itemId: shopItemId, amount: 1,
        }));
    };

    return {
        handleIncrease, handleDecrease, handleDelete,
    };
}

export default useModifyCartItem;
